import { SimpleWrapperRCP } from 'components/InputsMex/containers';
import { DropDown, TextInputOnBlur, DropDownFilterRCP } from 'components/InputsMex/inputs';
import { SimpleMaskInputField } from 'components/InputsMex/SimpleInputs';
import { emailRegex, inputNumericoEnteros } from 'components/InputsMex/validaciones';
import InformacionAgente from 'components/MisDatosForm/InformacionAgente';
import React, {useState} from 'react'
import { Button} from 'react-bootstrap';

import { regex } from 'utils/validaciones';
import { useFormContext } from 'react-hook-form';

const defaultDisclaimer = [{}, {}, {}];

export const DatosAsegurado = ({
    clavesAgente = [],
    catalogo: {
        mensajes = defaultDisclaimer,
        razonesSociales = [],
        tipoSolicitud = []
    },
    profesionesService = [],
    monedasService = [],
    sumasAseguradasService = [],
    loadingSumas = false,
    showSumas = false,
    bloqueo = false,
    cargaInicial,
    cargarSumasAseguradas = () => { },
    onChangeTipoSolicitud,
    requerimientoContractual
    
}) => {
    const methods = useFormContext();
      
    return (
        <div>
            <div className="d-flex justify-content-center">
                <div className="col-lg-8 col-12">
                    <div className="row w-100">
                        <div className="col-12 col-md-6  py-4">
                            <div className="container-accidentes">
                                <h3 className="font-mex text-center" style={{ fontSize: "30px" }}>
                                    Datos para la cotización
                                </h3>
                            </div>

                            <div className="form-group">
                                <SimpleWrapperRCP
                                    name="datosCotizacion.tipoSolicitudObj"
                                    label="Tipo de solicitud"
                                >
                                    <DropDownFilterRCP
                                        name="datosCotizacion.tipoSolicitudObj"
                                        options={
                                            tipoSolicitud.map((item) => ({
                                              label: item.label,
                                              value: item,
                                            })) || []
                                          }
                                        rules={{
                                            required: 'Este campo es obligatorio',
                                        }}
                                        onChangeFn={onChangeTipoSolicitud} 
                                    />
                                </SimpleWrapperRCP>
                            </div>
                            {requerimientoContractual && <div className="form-group">
                                <SimpleWrapperRCP
                                    name="datosCotizacion.razonSocialObj"
                                    label="Razón social"
                                >
                                    <DropDownFilterRCP
                                        name="datosCotizacion.razonSocialObj"
                                        options={
                                            razonesSociales.map((item) => ({
                                              label: item.label,
                                              value: item,
                                            })) || []
                                          }
                                        rules={{
                                            required: 'Este campo es obligatorio',
                                        }}
                                    />
                                </SimpleWrapperRCP>
                            </div>}
                            

                            {cargaInicial &&
                                <div>
                                    <div className="form-group">
                                        <SimpleWrapperRCP /* info={mensajes.find(msg => msg.tipo === "IngresoAnualBruto")?.texto} *//* label="Ingreso anual bruto*" */ 
                                        label={requerimientoContractual?"Monto del/los contrato(s)*":"Ingreso anual bruto*"} 
                                        name="datosCotizacion.ingresoAnualBruto">
                                            <TextInputOnBlur
                                                inputProps={{
                                                    name: 'datosCotizacion.ingresoAnualBruto',
                                                    type: 'number',
                                                    onKeyDown: inputNumericoEnteros,
                                                }}
                                                prefijo='$ '
                                                onBlur={() => { cargarSumasAseguradas() }}
                                                numerico={true}
                                                rules={{
                                                    required: 'Este campo es obligatorio',
                                                    validate: {
                                                        limites: (value) => (value === 0) ? 'Monto no válido' : true,
                                                    },
                                                }}
                                                extrasClasses="hide-arrows"
                                            />
                                        </SimpleWrapperRCP>
                                    </div>
                                    <div className="form-group">
                                        <SimpleWrapperRCP
                                            name="datosCotizacion.giroSeleccionado"
                                            label="Giro de servicios profesionales cubiertos"
                                        >
                                            <DropDownFilterRCP
                                                name="datosCotizacion.giroSeleccionado"
                                                options={profesionesService}
                                                onChangeFn={(value) => { cargarSumasAseguradas() }}
                                                rules={{
                                                    required: 'Este campo es obligatorio',
                                                }}
                                            />
                                        </SimpleWrapperRCP>
                                    </div>
                                    <div className="form-group">
                                        <SimpleWrapperRCP
                                            name="datosCotizacion.moneda"
                                            label="Moneda"
                                        >
                                            <DropDown
                                                name="datosCotizacion.moneda"
                                                options={monedasService}
                                                onChangeFn={(value) => { cargarSumasAseguradas() }}
                                                rules={{
                                                    required: 'Este campo es obligatorio',
                                                }}
                                            />
                                        </SimpleWrapperRCP>
                                        <div className="col-12 mt-3 mx-2">
                                            <p
                                                className="text-enviar-cotizacion"
                                                style={{ fontSize: "20px", fontFamily: "Futura-Medium" }}
                                            >
                                                {mensajes?.find(msg => msg?.tipo === "mensajeMoneda")?.texto || 'De Información y contratación.'}
                                            </p>
                                        </div>
                                    </div>

                                    {(showSumas) && <div className="form-group">
                                        <SimpleWrapperRCP label="Suma asegurada" name="datosCotizacion.sumaAsegurada">
                                            <DropDown
                                                name="datosCotizacion.sumaAsegurada"
                                                options={sumasAseguradasService}
                                                disabled={loadingSumas}
                                                loading={loadingSumas}
                                                empty
                                                rules={{
                                                    required: 'Este campo es obligatorio',
                                                }}
                                            />
                                        </SimpleWrapperRCP>
                                    </div>}

                                    <div className="container-accidentes">
                                        <div
                                            className="disclaimer-form-datos"
                                            style={{ fontSize: "15px", fontFamily: "Futura-Medium" }}
                                            dangerouslySetInnerHTML={{
                                                __html: mensajes?.find(msg => msg.tipo === 'Validacion')?.texto,
                                            }
                                            }
                                        />
                                    </div>


                                </div>
                            }
                            
                        </div>
                        <div className="col-12 col-md-6  py-4">
                            <div className="container-accidentes">
                                <h3 className="font-mex text-center" style={{ fontSize: "30px" }}>
                                    Datos personales
                                </h3>
                            </div>

                            <div className="form-group">
                                <SimpleWrapperRCP label="Nombre*" name="datosCliente.usuNombre">
                                    <TextInputOnBlur
                                        inputProps={{
                                            name: "datosCliente.usuNombre",
                                            type: "string",
                                        }}
                                        rules={{
                                            required: regex.requiredMessage,
                                            pattern: {
                                                value: regex.nombre.value,
                                                message: regex.nombre.mensaje,
                                            },
                                        }}
                                    />
                                </SimpleWrapperRCP>
                            </div>
                            <div className="form-group">
                                <SimpleWrapperRCP label="RFC del asegurado*" name="datosCliente.usuRfc">
                                    <TextInputOnBlur
                                        inputProps={{
                                            name: "datosCliente.usuRfc",
                                            // type: "number",
                                        }}
                                        extrasClasses="hide-arrows"
                                        rules={{
                                            required: 'Este campo es obligatorio',
                                            pattern: {
                                                value: /^[A-Z]{3,4}[0-9]{6}[A-Z0-9]{3}$/,
                                                message: "RFC incorrecto, el formato esperado es: AAAA######*** o AAA######***. Donde A es una letra, # es un número y los últimos 3 caracteres son alfanuméricos"
                                            },
                                            maxLength: {
                                                value: 13,
                                                message: "Ingrese hasta 13 caracteres",
                                            },
                                        }}
                                    />
                                </SimpleWrapperRCP>
                            </div>

                            <React.Fragment>
                                <div className="form-group container-accidentes">
                                    <SimpleMaskInputField
                                        name="datosCliente.usuTelefono"
                                        label="Teléfono (opcional)"
                                        type="mask"
                                        placeholder="999-9999-999"
                                        mask="999-9999-999"
                                        isNumberInt={true}
                                        inputProps={{
                                            name: "datosCliente.usuTelefono",
                                            type: "number",
                                            onKeyDown: inputNumericoEnteros,
                                        }}
                                        classContainer="hide-arrows"
                                        rules={{
                                            //  required: regex.requiredMessage,
                                            pattern: {
                                                value: regex.telefono10.value,
                                                message: regex.telefono10.mensaje,
                                            },
                                            minLength: {
                                                value: 10,
                                                message: "Debe ingresar mínimo 10 números",
                                            },
                                            maxLength: {
                                                value: 20,
                                                message: "Solo puede ingresar máximo 20 números",
                                            },
                                        }}
                                    />
                                </div>
                                <div className="form-group container-accidentes">
                                    <p
                                        className="text-enviar-cotizacion"
                                        style={{ fontSize: "20px", fontFamily: "Futura-Medium" }}
                                    >
                                        Compártenos tu correo para enviarte tu cotización
                                    </p>
                                </div>
                            </React.Fragment>


                            <div className="form-group">
                                <SimpleWrapperRCP label="Correo (opcional)" name="datosCliente.usuCorreo">
                                    <TextInputOnBlur
                                        inputProps={{
                                            name: "datosCliente.usuCorreo",
                                        }}
                                        rules={{
                                            // required: regex.requiredMessage,
                                            validate: {
                                                email: (value) => {
                                                    if (value === "") {
                                                        return true;
                                                    }
                                                    const valid = emailRegex.test(value);
                                                    if (!valid) {
                                                        return "Ingrese un correo válido";
                                                    }
                                                    return true;
                                                },
                                            },
                                        }}
                                    />
                                </SimpleWrapperRCP>
                            </div>


                            <div className="container-accidentes">
                                <div
                                    className="disclaimer-form-datos"
                                    style={{ fontSize: "15px", fontFamily: "Futura-Medium" }}
                                    dangerouslySetInnerHTML={{
                                        __html: mensajes?.find(msg => msg.tipo === 'Informativo')?.texto,
                                    }}
                                />
                            </div>
                            <div className="container-accidentes">
                                <div
                                    className="disclaimer-form-datos"
                                    style={{ fontSize: "15px", fontFamily: "Futura-Medium" }}
                                    dangerouslySetInnerHTML={{
                                        __html: mensajes?.find(msg => msg.tipo === 'Autorizacion')?.texto,
                                    }}
                                />
                            </div>
                            <InformacionAgente
                                className="mt-3"
                                border={false}
                                options={clavesAgente}
                            />
                            <div className="d-flex justify-content-center mt-5">
                                <Button disabled={bloqueo} type="submit" className="w-75">
                                    CONTINUAR
                                </Button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}


